import React, { useContext, useMemo } from "react";
import EditorParent from "@/base-components/EditorParent";
import { Context } from "@/App";
import ImportTable, { ImportColumn } from "./ImportTable";
import { createWorksite } from "@/api/worksite-controller";
import Worksite from "@/model/worksite";

type WorksiteImportRow = Omit<Worksite, "customer"> & { customerId: number };

const WorksiteImportPage: React.FC = () => {
    const { translations } = useContext(Context);
    const tw = translations.model.worksite;
    const ti = translations.importExport;

    const columns: ImportColumn<WorksiteImportRow>[] = useMemo(() => [
        { header: ti.customerId, fieldKey: "customerId", type: "number" },
        { header: tw.externalId, fieldKey: "externalId", type: "string" },
        { header: tw.name, fieldKey: "name", type: "string" },
        { header: tw.address, fieldKey: "address", type: "string" },
        { header: tw.postalCode, fieldKey: "postalCode", type: "string" },
        { header: tw.city, fieldKey: "city", type: "string" },
        { header: tw.notes, fieldKey: "notes", type: "string" },
        { header: tw.contactPerson, fieldKey: "contactPerson", type: "string" },
        { header: tw.contactEmail, fieldKey: "contactEmail", type: "string" },
        { header: tw.contactPhone, fieldKey: "contactPhone", type: "string" },
        { header: tw.identifier, fieldKey: "identifier", type: "string" },
        { header: tw.latitude, fieldKey: "latitude", type: "number" },
        { header: tw.longitude, fieldKey: "longitude", type: "number" },
    ], [tw, ti]);

    const buildPayload = (rowData: Record<string, any>) => ({
        id: 0,
        externalId: rowData.externalId || "",
        active: true,
        customer: rowData.customerId ? { id: Number(rowData.customerId) } : null,
        identifier: rowData.identifier || "",
        name: rowData.name || "",
        address: rowData.address || "",
        postalCode: rowData.postalCode || "",
        city: rowData.city || "",
        notes: rowData.notes || "",
        contactPerson: rowData.contactPerson || "",
        contactEmail: rowData.contactEmail || undefined,
        contactPhone: rowData.contactPhone || "",
        latitude: rowData.latitude ? Number(rowData.latitude) : 0,
        longitude: rowData.longitude ? Number(rowData.longitude) : 0,
        extraGeoData: "",
        attachedFiles: [],
        propertyValues: [],
    });

    return (
        <EditorParent title={ti.worksiteImport}>
            <ImportTable<WorksiteImportRow>
                columns={columns}
                createFn={createWorksite}
                buildPayload={buildPayload}
            />
        </EditorParent>
    );
};

export default WorksiteImportPage;
